module.exports = __webpack_public_path__ + "img/07_shimizu_22.cb14ba62.jpg";